import { SourceToolbar } from "../SourceToolbar";
import type { CableSourceToolbarOverlayProps } from "./types";

export const CableSourceToolbarOverlay = ({
  cableTakeoff,
}: CableSourceToolbarOverlayProps) => {
  const { selectedSource } = cableTakeoff;
  if (!selectedSource) return null;

  return (
    <div
      ref={cableTakeoff.sourceToolbarRef}
      data-testid="cable-source-toolbar"
      className="fixed z-50"
      style={{ left: selectedSource.screenX, top: selectedSource.screenY }}
    >
      <SourceToolbar
        label={selectedSource.label}
        geometry={cableTakeoff.effectiveCableGeometry}
        lengthsByCircuit={cableTakeoff.editableTakeoff.derivedLengthsByCircuit}
        sourceNames={cableTakeoff.editableTakeoff.sourceNames}
        provenance={cableTakeoff.selectedPlanTakeoff?.provenance ?? null}
        startMoveSource={cableTakeoff.cableDirectEdit.startMoveSource}
        removeSource={cableTakeoff.editableTakeoff.removeSource}
        renameSource={cableTakeoff.editableTakeoff.renameSource}
        resetSource={cableTakeoff.editableTakeoff.resetSource}
        onClose={() => cableTakeoff.setSelectedSource(null)}
        isTotalShown={cableTakeoff.editableTakeoff.isSetupDone}
      />
    </div>
  );
};
